import http from './HttpService';
import { API_BASE_CONTENT, API_BASE_PUBLISH, API_BASE_CAMPAIGN } from '../../constants/index';
import { getQueryAssetId } from 'modules/EmailBrowser/utils';
import axios from 'axios';

export function getDesignService(
  asset_id: number,
  templateStyleId: number,
  change_template: number,
  fromDesign: boolean,
) {
  return http.get(
    `${API_BASE_CONTENT}design/?version_id=${asset_id}&templateStyleId=${templateStyleId}&change_template=${change_template}&fromDesign=${fromDesign}`,
  );
}

export function regernationService(emailIds: number[], prompt: string, eventType: string) {
  let form_data = new FormData();
  emailIds.forEach((emailId) => {
    form_data.append('email_id', emailId.toString());
  });
  form_data.append('prompt', prompt);
  form_data.append('event_type', eventType);
  return http.post(API_BASE_CAMPAIGN + 'regenerate_ai_email/', form_data, {});
}

let cancelTokenSaveDesign: any;
export const saveDesignService = async (data: any) => {
  //Check if there are any previous pending requests
  if (typeof cancelTokenSaveDesign != typeof undefined) {
    cancelTokenSaveDesign && cancelTokenSaveDesign.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenSaveDesign = axios.CancelToken.source();
  return await http.post(`${API_BASE_CONTENT}design/save/`, data, {
    cancelToken: cancelTokenSaveDesign.token,
  });
};
export function authorizeStripoService() {
  return http.post(API_BASE_CONTENT + 'stripo/auth/', null);
}

export function generateRSSFeedService() {
  let asset_id = getQueryAssetId();
  // replace this with API
  return http.get(API_BASE_PUBLISH + `export_rss_link/?version_id=${asset_id}`);
}

export function getDesignPreviewService(asset_id: Number, assetType?: string, templateId?: number) {
  let url = API_BASE_PUBLISH + 'publish_html_preview/?version_id=' + asset_id;
  if (templateId) url += '&template_id=' + templateId;

  return http.get(url);
}
export function generateDesignPreviewService(
  campaignId: Number,
  assetId: Number,
  html_content?: string,
  email_html?: string,
  cssContent?: string,
  fromDesign?: boolean,
) {
  let data = new FormData();
  data.append('version_id', assetId?.toString());
  data.append('asset_id', campaignId?.toString());
  data.append('html_content', html_content !== undefined ? html_content : '');
  data.append('email_content', email_html !== undefined ? email_html : '');
  data.append('css_content', cssContent !== undefined ? cssContent : '');
  data.append('from_design', fromDesign !== undefined ? fromDesign.toString() : 'false');
  return http.post(API_BASE_CONTENT + 'generate_preview/', data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function updateTextPreviewService(asset_id: Number, textPreview: string) {
  var form_data = new FormData();
  form_data.append('version_id', asset_id.toString());
  form_data.append('text_preview', textPreview);
  return http.post(API_BASE_PUBLISH + 'update_text_preview/', form_data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function refreshTextPreviewService(asset_id: Number, emailContent: string) {
  var form_data = new FormData();
  form_data.append('version_id', asset_id.toString());
  form_data.append('email_content', emailContent);
  return http.post(API_BASE_CONTENT + 'default_text_preview/', form_data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function shareEmailOnSocialService(params?: any) {
  var form_data = new FormData();
  form_data.append('email_id', params.emailId);
  form_data.append('platform', params.platform);
  return http.post(API_BASE_PUBLISH + 'export/', form_data);
}

export const getDefaultTemplateService = (campaignId: number | string) => {
  return http.get(`${API_BASE_CAMPAIGN}default_template/?campaignId=${campaignId}`);
};

export const createAndUpdateDefaultTemplateService = (body: {
  campaignId: number | string;
  header?: string;
  footer?: string;
  signature?: string;
  template_style_id?: string | number;
}) => {
  return http.post(`${API_BASE_CAMPAIGN}default_template/`, body);
};
